<div class="search-bar-container">
  <app-svg [svg]="SVG_NAMES.search"></app-svg>
  <input type="text" class="search-input"
         (ngModelChange)="handleSearch($event)"
         [(ngModel)]="searchValue"
         placeholder="{{title}}">
</div>
